<div *ngIf="!isLoading; else spinner" >
  <h1 mat-dialog-title xmlns="http://www.w3.org/1999/html">
      <ng-container *ngIf="contact.contactName; else addTitle">Edit Contact</ng-container>
  </h1>
  <mat-dialog-content [formGroup]="formGroup">
    <div class="form-container">
      <mat-checkbox id='publishCheckbox' [(ngModel)]="contact.okToPublish" formControlName="okToPublish">Ok to publish</mat-checkbox>
      <mat-form-field>
        <input matInput
               placeholder="Title/Dept *"
               formControlName="titleDept"
               [(ngModel)]="contact.titleDept">
      </mat-form-field>
      <mat-form-field>
        <input matInput
               placeholder="Name *"
               formControlName="name"
               [(ngModel)]="contact.contactName">
      </mat-form-field>
      <mat-form-field>
        <input #phone
               matInput
               placeholder="Phone"
               formControlName="phone"
               maxlength="14"
               (blur)="phoneFieldBlur('phone')"
               (keyup)="phoneFieldKeyUp($event, 'phone', phone)">
      </mat-form-field>
      <mat-form-field>
        <input matInput
               placeholder="Email"
               formControlName="email"
        [(ngModel)]="contact.email">
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="mat-raised-button submit-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
<ng-template #addTitle>
  Add Contact
</ng-template>
